/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_Turn_OnInputs */

const en_simple_home_banner_turn_on = /** @type {(inputs: Simple_Home_Banner_Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on simple mode`)
};

const id_simple_home_banner_turn_on = /** @type {(inputs: Simple_Home_Banner_Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan mode sederhana`)
};

/**
* | output |
* | --- |
* | "Turn on simple mode" |
*
* @param {Simple_Home_Banner_Turn_OnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_turn_on = /** @type {((inputs?: Simple_Home_Banner_Turn_OnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_Turn_OnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_turn_on(inputs)
	return en_simple_home_banner_turn_on(inputs)
});